
import {takeUntil} from 'rxjs/operators';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ITenaSegment } from '../../../../model/product/tena/ITenaSegment';
import { TenaService } from '../../Tena.service';
import { TenaUserSegmentApi } from '../../../../api/product/tena/tcw/TenaUserSegmentApi';

@Component({
    selector: 'admin-tena-segment-select',
    templateUrl: 'TenaSegmentSelect.component.html',
    providers: [TenaUserSegmentApi]
})
export class TenaSegmentSelectComponent implements OnInit, OnDestroy {
    segmentForm: FormGroup;
    segments: ITenaSegment[];

    @Input()
    selectedSegment: ITenaSegment;

    @Input()
    modalVisible: boolean;

    private unsubscribe: Subject<void> = new Subject();

    constructor(
        public tenaService: TenaService,
        private tenaSegmentsApi: TenaUserSegmentApi,
        private fb: FormBuilder
    ) {}

    ngOnInit() {
        this.tenaService.segments.pipe(
            takeUntil(this.unsubscribe))
            .subscribe((segments: ITenaSegment[]) => {
                this.segments = segments;
            });

        this.segmentForm = this.fb.group({
            segment: new FormControl(
                this.selectedSegment ? this.selectedSegment.objectId.toString() : '',
                Validators.required
            )
        });

        this.tenaSegmentsApi.getAll().subscribe((res: ITenaSegment[]) => {
            let consumerSegments = res.filter(segment => segment.isConsumerSegment);
            this.tenaService.segments.next(consumerSegments);
        });

        this.tenaService.segmentModalVisible.pipe(
            takeUntil(this.unsubscribe))
            .subscribe(visible => {
                this.toggleSegmentModal(visible);
            });

        this.toggleSegmentModal(this.modalVisible);
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    selectSegment(segment: ITenaSegment) {
        if (this.segmentForm.valid) {
            segment = this.segments.find((item: ITenaSegment) => {
                if (item.objectId === parseInt(this.segmentForm.value.segment)) {
                    return true;
                }
            });
            window.sessionStorage.setItem('tenaSelectedSegment', JSON.stringify(segment));
            this.tenaService.segmentChanged.next(segment);

            this.tenaService.segmentModalVisible.next(false);
        }
    }

    toggleSegmentModal(show: boolean) {
        if (show) {
            document.getElementsByTagName('body')[0].className = 'modal-open';
        } else {
            document.getElementsByTagName('body')[0].classList.remove('modal-open');
        }
    }
}
